import staffService from "services/staffService";
import volunteerService from "services/volunteerService";

/**
 * Audience config for the public intake and pulse flows. Staff and volunteer pages
 * share one implementation; only the API service differs.
 */
export const PUBLIC_AUDIENCES = {
  staff: { service: staffService },
  volunteer: { service: volunteerService },
};
